import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getShareLink } from 'components/Modal/ShareLinkModal/actions';

const useGetShareLink = (jobId: number) => {
  const dispatch = useDispatch();

  const getShareLinkHandler = useCallback(() => {
    dispatch(getShareLink(jobId));
  }, [dispatch, jobId]);

  return { getShareLinkHandler };
};

export default useGetShareLink;
